/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const relevantContactResponseDtoSchema = z.object({
    "contactId": z.string(),
"fullName": z.nullable(z.string()),
"firstName": z.nullable(z.string()),
"lastName": z.nullable(z.string()),
"preferredName": z.nullable(z.string()),
"company": z.nullable(z.string()),
"leadId": z.string(),
"leadIntent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]),
"leadStage": z.enum(["NEW", "NURTURE", "WARM", "HOT", "UNDER_CONTRACT", "CLOSED", "LOST"]),
"lastSignalAt": z.iso.datetime(),
"recentActivity": z.string().describe("Short overview of recent lead activity")
    })